const BreadcrumbNameMap = {
    '/entrance/home':'首页',
    '/entrance/governmentService':'政务服务', 
    '/entrance/convenience':'便民服务',
  };
  export default BreadcrumbNameMap